"use client";
export default function Error({ error, reset }) {
  return (
    <div className="error-page">
      <h1 className="text-2xl">發生錯誤...!</h1>
      <p>{error.message}</p>
      <button
        className="bg-primary-blue w-[150px] text-white px-3 py-2 rounded-[100vmax]"
        onClick={reset}
      >
        回首頁
      </button>
    </div>
  );
}
